// localpickup.js - NEUTRALISÉ
class LocalPickup extends HTMLElement {
  connectedCallback() {
    // Script neutralisé, aucun message ni fonctionnalité de retrait
  }
}

// Définit l'élément personnalisé si ce n'est pas déjà fait
if (!customElements.get('local-pickup')) {
  customElements.define('local-pickup', LocalPickup);
}
